import * as Colors from "../../../../globalStyles/administratorColors";

export const body = {
    paddingRight: "30px",
    paddingTop: "30px"
};

export const editItemsBtn = {
    textAlign: "right"
};

export const cardStyleHeadings = {
    background: Colors.primary,
    color: "white"
};

export const cardStyle = {
    background: Colors.primary,
    color: "white",
    cursor: "pointer"
};

export const scrollableBox = {
    height: "500px",
    overlow: "auto",
    overflowX: "hidden"
};

export const doubleClickMessage = {
    fontSize: "1.5rem",
    fontWeight: "bold"
};

export const itemsTable = {
    textAlign: "center",
    borderCollapse: "collapse"
};

export const tableHeadings = {
    fontWeight: "bold",
    border: "solid 1px black"
};

export const tableCells = {
    border: "solid 1px black"
};

export const minMaxSection = {
    textAlign: "right"
};

export const lengthCounter = {
    textAlign: "right",
    color: "red"
};

export const quotePoundSign = {
    margin: "auto",
    textAlign: "right"
};

export const quoteBox = {
    marginLeft: 0,
    textAlign: "right",
    padding: "0"
};
